import { inject, Injectable } from '@angular/core';

import type { HtmlClassMenuController, HtmlClassMenuOpenOptions } from '@core/prosemirror-legacy';
import type { DialogRef } from '@core/user-interface-legacy';
import { DialogService, DialogWidth } from '@core/user-interface-legacy';

import { HtmlClassDialogComponent } from './html-class-dialog.component';

@Injectable()
export class HtmlClassMenuService implements HtmlClassMenuController {
  private readonly dialogSvc = inject(DialogService);
  private dialogRef: DialogRef | null = null;

  public open = (options: HtmlClassMenuOpenOptions) => {
    this.dialogRef = this.dialogSvc.openCustom(
      HtmlClassDialogComponent,
      { width: DialogWidth.SmallX },
      { initial: options.initial },
    );
    this.dialogRef.afterClosed.subscribe((result: string | undefined) => {
      if (result !== undefined) {
        options.apply(result);
      }
      this.dialogRef = null;
    });
  };

  public close = () => {
    this.dialogRef?.close();
  };

  public isOpen = () => !!this.dialogRef;
}
